import React from 'react';
import styles from './styles.module.css';
import { motion, TargetAndTransition, useAnimation } from 'framer-motion';
import correctAnswerSfx from '../../assets/sounds/correct-answer-tone.mp3';

export interface PerformanceTimelineProps{
    duration?: number;
    stop?: boolean;
    segments?: number;
}

interface TimeLineSegmentProps{
    color?: string;
    showLineSeparator?: boolean;
    startLabel?: string;
    endLabel?: string;
    glow?: boolean;
}

const sectionSound = new Audio(correctAnswerSfx);

const TimeLineSegment: React.FC<TimeLineSegmentProps> = ({
    startLabel, endLabel, color, showLineSeparator, glow
})=>{

    return(
        <div 
            className={styles.timeline} 
            style={{ 
                backgroundColor: color,
                boxShadow: glow ? `0px 0px 15px 5px ${color}` : undefined
            }}
        >
            <div className={styles.markerContainer}>
                { showLineSeparator && <div className={styles.marker}/> }
                { startLabel && <p>{ startLabel }</p> }
                { endLabel && <p>{ endLabel }</p> }
            </div>
        </div>
    )
}

const PerformanceTimeline: React.FC<PerformanceTimelineProps> = ({
    duration = 60, stop = false, segments = 4
})=>{

    // Ref
    const sirenCountRef = React.useRef(0);

    // Hooks
    const controls = useAnimation();
    
    // State
    const [activeIndex, setActiveIndex] = React.useState<number>(0)

    // Animations
    let rightTransition = React.useRef<TargetAndTransition>({
        left: 'calc(100% - 6px)',
        transition:{
            duration: duration,
            ease: 'linear'
        }
    })

    // Effects
    React.useEffect(()=>{
        controls.start(rightTransition.current);
    },[]);

    React.useEffect(()=>{
        if (stop) {
            controls.stop();
        }
    },[stop]);

    React.useEffect(()=>{
        let sirenInterval = setInterval(()=>{
            if (sirenCountRef.current < (segments - 1)) {
                console.log(`siren count for ${(duration * 1000)/segments}: `, sirenCountRef.current)
                setActiveIndex((prevIndex) => prevIndex + 1)
                sectionSound.play();
                sirenCountRef.current += 1;
            }
        }, (duration * 1000)/segments);

        return ()=> clearInterval(sirenInterval);
    },[])


    // Helpers
    const renderTimeline = ()=>{
        let colorGrade = [
            "#C40700",
            "#ff8c00",
            "#f6ff00",
            // "#adf0ad",
            "#4bc400",
        ];
        let timelineSegments = [];

        for (let i = 0; i < segments; i++) {

            let startLabel = `${i}s`;
            let endLabel = (duration/segments) * (i + 1) + 's';
            let color = colorGrade[i] ? colorGrade[i] : undefined;
            let showLineSeparator = i !== segments - 1;

            timelineSegments.push(
                <TimeLineSegment
                    startLabel={i === 0 ? startLabel : undefined}
                    endLabel={endLabel}
                    color={color}
                    glow={activeIndex === i}
                    showLineSeparator={showLineSeparator}
                />
            )
            
        }

        return timelineSegments;
    }

    return(
        <div>
            <div className={styles.timelineContainer}>

                {/** Timeline */}
                <div className={styles.timelineFlex}>

                    { renderTimeline() }

                    {/** Red Segment */}
                    {/* <div className={styles.timeline}>
                        <div className={styles.markerContainer}>
                            <div className={styles.marker}/>
                            <p>0</p>
                            <p>15s</p>
                        </div>
                    </div> */}

                    {/** Orange Segment */}
                    {/* <div className={styles.timeline} style={{ backgroundColor: '#ff8c00' }}>
                        <div className={styles.markerContainer}>
                            <div className={styles.marker}/>
                            <p>30s</p>
                        </div>
                    </div> */}

                    {/** Yellow Segment */}
                    {/* <div className={styles.timeline} style={{ backgroundColor: '#f6ff00' }}>
                        <div className={styles.markerContainer}>
                            <div className={styles.marker}/>
                            <p>45s</p>
                        </div>
                    </div> */}

                    {/* <div className={styles.timeline} style={{ backgroundColor: '#4bc400' }}>
                        <div className={styles.markerContainer}>
                            <p>60s</p>
                        </div>
                    </div> */}
                </div>

                {/** Cursor */}
                <motion.div 
                    className={styles.cursor}
                    animate={controls}
                    transition={{ duration: 5 }}
                />
            </div>
            <div className={styles.labelFlex}>
                <p>0%</p>
                <p>50%</p>
                <p>100%</p>
                <p>150%</p>
            </div>
        </div>
    )
}

export default PerformanceTimeline;